module.exports = __webpack_public_path__ + "img/chinesecompany03.c3b9d98e.png";